import { useState, useEffect, useContext } from "react";
import { Status_func } from "../../api/troubleshoot/status_func";
import { SideMenu } from "../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../components/data_table/data_table.component";
import OverLay from "../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Subtitle2Stronger, Input, ButtonProps, Tooltip, ProgressBar } from "@fluentui/react-components";
import { DesktopCheckmark20Regular, AlertBadge20Regular, WrenchScrewdriver20Regular, Filter20Filled, FilterDismiss20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Dismiss16Regular, CheckmarkLock20Regular, FilterAdd20Filled, Info16Filled, Settings20Regular } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../components/dropdown/menu.component";
import { DropdownComponent } from "../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen";
import { ToastComponent } from "../../components/toast/toast.component";
import { Status_target_fun } from "../../api/troubleshoot/status_target_fun";
import { primaryIcon, overflowDivider, secondaryIcon, lightTheme, skeleton11, skeleton12, skeleton8, dividerWidthStyle, DynamicBoxingCSS, SubSectionResponsive, parentHome, wraperStyle, buttonContent, dashboardTheme, BreadcrumbsBorder, timezoneInfo } from "../../styles/customStyles";
import { usePermissionStore } from "../../Store/permissionStore";
import { SkeletonDataTable } from "../../components/skeleton/skeletonDataTable";
import { GlobalContext } from "../../hooks/globalContext";
import { convertToLocalTimezone, convertUTCToReadableFormat, convertToExcelFormat } from "../../utility/utils";
import FullScreenButton from "../../components/fullscreen/fullScreen.component";
import { DatepickerComponent } from "../../components/picker/datepicker.component";
import { SearchBar } from "../../components/searchbar/searchbar.component";
import { InfoBar } from "../../components/infoBar/infoBar.component";
import DynamicSkeleton from "../../components/skeleton/skeletonCommon";
import { SkeletonOverlayDataTable } from "../../components/skeleton/skeletonOverlayDataTable";
import { TroubleshootPages } from "../../components/side_menu/InlineSidenav";

const handleExportCSV = () => {
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

interface AuditData {
  JobCreatedTime: number;
  SelectionType: string;
  AgentName: string;
  AgentUniqId: string;
  automationName: string;
  createdBy: string;
  category: string;
  description: string;
  automation_sequence: string;
}

interface AutomationJSONData {
  id: number;
  dartid: number;
  automationName: string;
  jsonvalue: string;
}
export const Status = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  var userTimeZone = contextValue.userSessionDetails?.otherDetails?.TimeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formattedTimeZone = userTimeZone.replace('_', ' ').replace('/', ' / ');
  const [final_data, set_final_data]: any = useState(null);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [searchDeviceVal, setSearchDeviceVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [isfilter, setIsFilter] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const handle = useFullScreenHandle();
  const [isRefresh, setIsRefresh]: any = useState(false);
  const [refreshToast, setRefreshToast]: any = useState(false);
  const [isToast, setIsToast] = useState(false);
  const [final_data2, set_final_data2]: any = useState([]);
  const [selectedActivity, setselectedActivity] = useState({ name: '', time: '' });
  const [automationName, setAutomationName] = useState('');
  const [createdBy, setCreatedBy] = useState('');
  const [jsonValue, setJsonValue]: any = useState(null);
  const [automationJsonAuditData, setAutomationJsonAuditData] = useState<AuditData[]>([]);
  const [automationJsonData, setAutomationJsonData] = useState<AutomationJSONData[]>([]);
  const [automationIds, setAutomationIds] = useState<any[]>([]);
  const [final_Targetdata, set_final_Targetdata]: any = useState(null);
  const [statusTableData, setStatusTableData] = useState([]);
  const [searchTargetVal, setSearchTargetVal] = useState("");
  const [uniqueAutomationNames, setUniqueAutomationNames] = useState<string[]>([]);
  const { permissions } = usePermissionStore();
  const [loading, setLoading] = useState(true);
  const [loadingTable, setLoadingTable] = useState(true);
  const [loadingAutomationData, setLoadingAutomationData] = useState(true);

  const [exportBtnClicked, setExportBtnClicked] = useState(false);
  const [exportDetails, setExportDetails] = useState<any[]>([]);
  //filter functionality state variables
  const [isOverlayFilter, setIsOverlayFilter] = useState(false);
  const [dropDownValue1Overlay, setDropDownValue1Overlay] = useState<any>();
  const [dropDownValue2Overlay, setDropDownValue2Overlay] = useState<any>();
  const [filterMenuOpenOverlay, setFilterMenuOpenOverlay] = useState(false);
  const [deviceSearchVal, setDeviceSearchVal] = useState("");
  const [overlayFilterArray, setOverlayFilterArray] = useState<string[]>([]);
  const [isOverlayFilterResetDisabled, setOverlayFilterResetDisabled] = useState(true);
  const [totalOverlayPages, setTotalOverlayPages] = useState(1);
  const [currentOverlayPageNo, setCurrentOverlayPageNo] = useState(1);
  const [totalOverlayRecords, setTotalOverlayRecords] = useState(0);

  const [isProgressLoading, setProgressLoading] = useState(false);
  const [isOverlayProgressLoading, setOverlayProgressLoading] = useState(false);
  const [overlayExportBtnClicked, setOverlayExportBtnClicked] = useState(false);
  const [overlayExportDetails, setOverlayExportDetails] = useState<any[]>([]);
  const [exportOverlayStatusData, setExportOverlayStatusData] = useState([]);
  const [tableColumnsData, setTableColumnsData] = useState([]);
	const [filterColumnsData, setFilterColumnsData] = useState([]);
  const pageName = "Interactive";
  console.log("checking the permissions------>", permissions)

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    const result = value1 + " : " + value2;
    setFilterArray([...filterArray, result])
    setIsFilter(true);
    setLoading(true);
    setDropDownValue1('');
    setDropDownValue2('');
  }

  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
    setLoading(true);
  }

  const handleOverlayFilter = (): any => {
    const value1 = dropDownValue1Overlay;
    const value2 = dropDownValue2Overlay;
    const result = value1 + " : " + value2;
    console.log('handleOverlayFilter result: ', result);
    setOverlayFilterArray([...overlayFilterArray, result])
    console.log('overlayFilterArray result: ', overlayFilterArray);
    setIsOverlayFilter(true);
    setLoadingTable(true);
    setDropDownValue1Overlay('');
    setDropDownValue2Overlay('');
  }

  const overlayInputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9 ]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1Overlay === ("Device Name") || dropDownValue1Overlay === ("Solution Status")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }

    if (name === 'filter' && dropDownValue1Overlay === ("Executed Time")) {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2Overlay(enteredValue);
      }
    }
  }

  const handleCloseOverlayFilter = (index: any): any => {
    console.log(" handleCloseOverlayFilter clicked");
    const updatedArray = overlayFilterArray.filter((x, itemIndex) => itemIndex !== index);
    console.log('updatedArray: ', updatedArray);
    setOverlayFilterArray(updatedArray);
    setLoadingTable(true);
    // setIsOverlayFilter(false);
  }
  useEffect(() => {
    if (filterArray.length > 0) {
      setResetDisabled(false);
    }
    else {
      setResetDisabled(true);
    }
    if (overlayFilterArray.length > 0) {
      setOverlayFilterResetDisabled(false);
      setIsOverlayFilter(true);
    }
    else {
      setOverlayFilterResetDisabled(true);
      setIsOverlayFilter(false);
    }
  }, [filterArray, overlayFilterArray])

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    const regexS = /^[A-Za-z ]*$/;
    const regexSN = /^[A-Za-z0-9-_ ]*$/;
    const regexN = /^[0-9]*$/;
    if (name === 'filter' && dropDownValue1 == "Solution" || dropDownValue1 === "Scope") {
      if (regexSN.test(enteredValue)) {
        setDropDownValue2(enteredValue)
      }
    }
    if (name === 'filter' && dropDownValue1 === "Initiated by") {
      if (regexS.test(enteredValue)) {
        setDropDownValue2(enteredValue)
      }
    }
  }

  //data table column name code starts here
  // var columns = [
  //   { key: "JobCreatedTime", label: <Body1Strong> Date (UTC) </Body1Strong> },
  //   { key: "JobCreatedTime_timezoned",
  //     label: <>
  //       <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
  //         <StackItem>
  //           <Body1Strong>&nbsp;&nbsp;Date</Body1Strong>
  //         </StackItem>
  //         <StackItem align="center">
  //           <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
  //             <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
  //           </Tooltip>
  //         </StackItem>
  //       </Stack>
  //     </>
  //   },
  //   { key: "Module", label: <Body1Strong> Module </Body1Strong> },
  //   { key: "ProfileName", label: <Body1Strong> Solution </Body1Strong> },
  //   { key: "MachineTag", label: <Body1Strong> Scope </Body1Strong> },
  //   // { key: "AgentName", label: <Body1Strong> Initiated by </Body1Strong> },
  //   { key: "AgentUniqId", label: <Body1Strong> Initiated by </Body1Strong> },
  //   // { key: "JobStatus", label: <Body1Strong> Status </Body1Strong> },
  // ];
  //data table column name code ends here

  //data table for filter starts here
  // var columns1 = [
  //   { key: "JobCreatedTime", label: <Caption1> Date </Caption1> },
  //   { key: "ProfileName", label: <Caption1> Solution </Caption1> },
  //   // { key: "SelectionType", label: <Caption1> Description </Caption1> },
  //   { key: "MachineTag", label: <Caption1> Scope </Caption1> },
  //   { key: "AgentUniqId", label: <Caption1> Initiated by </Caption1> },
  //   // { key: "JobStatus", label: <Caption1> Status </Caption1> },
  // ];

  var tableColumns: any[] = [];
	var filterColumns: any[] = [];
  useEffect(() => {
    contextValue?.tableColumnsData?.apps?.Status.forEach((val) => {
      if (val.display.table.toLocaleLowerCase() === "yes" && val.priority >= 0) {
        if (val.key === "JobCreatedTime_timezoned") {
          tableColumns[val.priority] = ({
            key: val.key,
            label:
              <>
                <Stack enableScopedSelectors horizontal tokens={{ childrenGap: 5 }} horizontalAlign="center">
                  <StackItem>
                    <Body1Strong>{`${val.name}`}</Body1Strong>
                  </StackItem>
                  <StackItem align="center">
                    <Tooltip withArrow content={`Timezone : ${formattedTimeZone}`} relationship="description" positioning="above">
                      <Info16Filled style={{ display: "flex" }} {...timezoneInfo} />
                    </Tooltip>
                  </StackItem>
                </Stack>
              </>
          });
        } else {
          tableColumns[val.priority] = ({ key: val.key, label: <Body1Strong> {val.name} </Body1Strong> });
        }
      }

      if (val.display.filter.toLocaleLowerCase() === "yes") {
        filterColumns.push({ key: val.key, label: <Caption1> {val.name} </Caption1> });
      }
    });

    setTableColumnsData(tableColumns);
    setFilterColumnsData(filterColumns);

    contextValue.setManageViewDropDownData(contextValue?.tableColumnsData?.apps?.Status.filter((val) => val.priority >= 0));

    contextValue.setManageViewPageDetails({ module: "apps", page: "Status" });
  }, [contextValue.tableColumnsData]);


  //overlay datatable code start here
  var overlayColumns = [
    { key: "dname", label: <Body1Strong> Device Name</Body1Strong> },
    { key: "status", label: <Body1Strong> Solution Status </Body1Strong> },
    { key: "exetime", label: <Body1Strong> Executed Time </Body1Strong> },
  ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true) }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        <StackItem>
          {
            permissions.includes("all") || permissions.includes("status_Fullaccess") || permissions.includes("status_ReadandExport") ?
              <StackItem>
                <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_statuslist.csv`}>
                </CSVLink>
                <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => { setExportBtnClicked(true); setProgressLoading(true); }}>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                    <StackItem> <Caption1> Export </Caption1> </StackItem>
                  </Stack>
                </Button>
              </StackItem>
              :
              <Tooltip withArrow content={"You do not have access"} relationship="description" positioning="above">
                <Button shape="circular" appearance="subtle" size="small" disabled>
                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                    <StackItem><Text></Text></StackItem>
                    <StackItem>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem> <ArrowDownload20Regular {...secondaryIcon} /> </StackItem>
                        <StackItem><Caption1> Export </Caption1></StackItem>
                      </Stack>
                    </StackItem>
                  </Stack>
                </Button>
              </Tooltip>
          }
        </StackItem>

        <StackItem>
          <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => document.getElementById("manageView").click()}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem> {loading || tableData.length === 0 ? <Settings20Regular {...secondaryIcon} /> : <Settings20Regular {...primaryIcon} />} </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>
        
        <StackItem grow shrink>
          <Stack horizontalAlign="end">
            <StackItem grow shrink>
              <FullScreenButton handle={handle} />
            </StackItem>
          </Stack>
        </StackItem>
      </>
    ,
  };
  // overflow set contents code ends here

  var timer: any;
  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];
  var tempStatusExport: any = [];
  var message: any;

  useEffect(() => {
    var tempExportData: any = [];

    exportDetails?.length > 0 && exportDetails.map((val: any) => {
      const WordSelectionType = val.SelectionType.split(':')[0].trim();
      console.log('WordSelectionType: ', WordSelectionType)
      let Scope = WordSelectionType === 'All Devices' ? 'All Devices' : WordSelectionType === 'Machine' || WordSelectionType === '' ? (
        "Machine"
      ) : (
        "WordSelectionType"
      )

      const statusdata = val.JobStatus;
      if (statusdata === 0) {
        message = 'Pending';
      } else if (statusdata === 2) {
        message = 'Success';
      } else if (statusdata === 3) {
        message = 'Failed';
      } else {
        message = 'Failed';
      }

      tempExportData.push({
        "Date": val.JobCreatedTime ? convertToExcelFormat(val.JobCreatedTime) : " -",
        "Solution": val.ProfileName ? decodeURIComponent(val.ProfileName) : " -",
        "Scope": Scope ? Scope : " -",
        "Initiated By": val.AgentUniqId ? val.AgentUniqId : " -",
        "Machine Tag": val.MachineTag ? val.MachineTag : " -",
        "Module Name": val.JobType ? val.JobType : " -",
      });
    });

    setExportData(tempExportData);
  }, [exportDetails]);

  useEffect(() => {
    exportData.length > 0 && document.getElementById('csv-export-link')?.click();
    setProgressLoading(false);
  }, [exportData]);

  useEffect(() => {
    console.log("final_data=", final_data);
    const uniqueTimes = new Set();
    let filterdata = final_data !== undefined && final_data !== null && final_data.filter((entry: any) => {
      if (!uniqueTimes.has(entry.JobCreatedTime)) {
        uniqueTimes.add(entry.ProfileName);
        return true;
      }
      return false;
    })
    console.log("filterdataaa=====  ", filterdata);
    console.log("filterdataaa=====  ", uniqueTimes);
    final_data !== undefined && final_data !== null
      ? final_data.map((val: any, i: any) => {
        let profilename = decodeURIComponent(val.ProfileName);
        let moduleName = val.JobType == 'Interactive' && 'Troubleshoot' || val.JobType == 'Alert' && 'Alert' || val.JobType == 'CompliancePolicy' && 'CompliancePolicy';
        // let profilename = ProfileNameval.replace(/%20/g, ' ');
        const WordSelectionType = val.SelectionType.split(':')[0].trim();
        console.log('WordSelectionType: ', WordSelectionType)
        // menuLists.push();
        tempTableData.push({
          checkbox: "hide",
          JobCreatedTime: {
            label:
              <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => {
                setOverlayOpen(true); setselectedActivity({
                  name: profilename, time: val.JobCreatedTime,
                })
                setLoadingAutomationData(true);
                setLoadingTable(true);
                set_final_data2([]);
              }}>
                {convertUTCToReadableFormat(val.JobCreatedTime)}
              </Button>, id: `${i}`
          },
          JobCreatedTime_timezoned: {
            label:
              <Button id="ButtonHover" style={buttonContent} appearance="transparent" size="small" onClick={() => {
                setOverlayOpen(true); setselectedActivity({
                  name: profilename, time: val.JobCreatedTime,
                })
                setLoadingAutomationData(true);
                setLoadingTable(true);
                set_final_data2([]);
              }}>
                {convertToLocalTimezone(val.JobCreatedTime, userTimeZone)}
              </Button>, id: `${i}`
          },
          Module: { label: <Caption1> {moduleName} </Caption1> },
          ProfileName: { label: <Caption1> {profilename} </Caption1>, status: "" },
          MachineTag: {
            label: <Caption1> {WordSelectionType === 'All Devices' ? (
              <span> All Devices </span>
            ) : WordSelectionType === 'Machine' || WordSelectionType === '' ? (
              <span> Machine</span>
            ) : (
              <span> {`Classification: ${WordSelectionType}`} </span>
            )}</Caption1>
          },
          AgentUniqId: { label: <Caption1> {(val.AgentUniqId !== null && val.AgentUniqId !== undefined && val.AgentUniqId.length > 0) ? val.AgentUniqId : '-'} </Caption1>, icon: "", status: "" },
          JobStatus: { label: <Caption1>{message} </Caption1> },
        })

      }) : (tempTableData = []);
    console.log("tempTableData=", tempTableData);
    tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
    console.log("tabledata before ->  ", tableData)
    setTimeout(() => {
      setTimeout(() => {
        final_data !== undefined && final_data !== null && setLoading(false);
        if (isRefresh) {
          console.log("FIRST CALL");
          setIsRefresh(false);
          setRefreshToast(true);
          setTimeout(() => {
          setRefreshToast(false);
          }, 3000);
      }
      }, 500);
    }, 500);
  }, [final_data, permissions]);
  // data table values append code ends here

  useEffect(() => {
    // Overlay activity status values append code starts here
    console.log("final_data status overlay--------", final_data2);

    final_data2 !== undefined && final_data2 !== null
      ? final_data2 && final_data2.map((actVal: any, i: any) => {
        console.log('actVal :', actVal);
        setAutomationName(actVal.AutomationJSON.automationName);
        setCreatedBy(actVal.AutomationJSON.createdBy);
        const dataObject = JSON.parse(actVal.AutomationJSON.jsonValue);
        console.log('dataObject:', dataObject);
        setJsonValue(dataObject);

        if (actVal && actVal.AutomationJSON) {
          const automationData = actVal.AutomationJSON;

          // Parse the jsonValue string to an object
          const jsonValueObj = JSON.parse(automationData.jsonValue);

          // Create an object that matches the structure expected by the rendering code
          const processedData = {
            JobCreatedTime: actVal.JobCreatedTime,
            SelectionType: actVal.SelectionType,
            AgentName: actVal.AgentName,
            AgentUniqId: actVal.AgentUniqId,

            // Include parsed data from AutomationJSON
            automationName: automationData.automationName,
            createdBy: automationData.createdBy,
            category: jsonValueObj.category,
            description: jsonValueObj.description,
            automation_sequence: jsonValueObj.automation_sequence
          };
          setTimeout(() => {
            final_data2 !== undefined && final_data2 !== null && setLoadingAutomationData(false);
          }, 500);
          setAutomationJsonAuditData([processedData]);  // Wrap in array to match state type
        } else {
          setTimeout(() => {
            final_data2 !== undefined && final_data2 !== null && setLoadingAutomationData(false);
          }, 500);
          console.log("AutomationJSON is missing or invalid");
          setAutomationJsonAuditData([]);
        }

      }) : (console.log("null"));
  }, [final_data2, selectedActivity]);



  useEffect(() => {
    // Overlay data table values append code starts here
    console.log("Status final_Targetdata ---------->", final_Targetdata);
    final_Targetdata !== undefined && final_Targetdata !== null
      ? final_Targetdata.map((val: any, i: any) => {

        const deviceData = val && val.AutomationJSON;
        console.log('deviceData = ' + deviceData)
        // let auditData = deviceData && deviceData.map((data: any, i: any) => {
        //   return data;
        // })

        // if (auditData) {
        // val.forEach((data: any, i: any) => {
        console.log('data=============-->', val)
        const statusdata = val.JobStatus;
        if (statusdata === 0) {
          message = 'Pending';
        } else if (statusdata === 2) {
          message = 'Success';
        } else if (statusdata === 3) {
          message = 'Failed';
        } else {
          message = 'Failed';
        }
        tempStatusExport.push({
          DeviceName: val.MachineTag,
          SolutionStatus: message,
          ExecutedTime: val.ClientExecutedTime != null ? convertToExcelFormat(val.ClientExecutedTime) : '-',
        });

        if (contextValue.logedInFrom !== undefined && contextValue.logedInFrom?.platform === "ServiceNow") {
          contextValue.logedInFrom?.device === val.MachineTag && tempTableData.push({
            id: val.MachineTag,
            checkbox: "hide",
            dname: { label: <Caption1> {val.MachineTag}  </Caption1>, icon: "", id: `${i}` },
            status: { label: <Caption1> {message} </Caption1>, icon: "", status: "" },
            exetime: {
              label: <Caption1> {val.ClientExecutedTime != null ? convertUTCToReadableFormat(val.ClientExecutedTime) : '--'} </Caption1>, icon: ""
            }
          });
        } else {
          tempTableData.push({
            id: val.MachineTag,
            checkbox: "hide",
            dname: { label: <Caption1> {val.MachineTag}  </Caption1>, icon: "", id: `${i}` },
            status: { label: <Caption1> {message} </Caption1>, icon: "", status: "" },
            exetime: {
              label: <Caption1> {val.ClientExecutedTime != null ? convertUTCToReadableFormat(val.ClientExecutedTime) : '--'} </Caption1>, icon: ""
            }
          });
        }
        // });
        // }

      }) : (tempTableData = []);
    // setExportStatusData(tempStatusExport);

    tempTableData.length > 0 ? setStatusTableData(tempTableData) : setStatusTableData([]);
    setTimeout(() => {
      final_Targetdata !== undefined && final_Targetdata !== null && setLoadingTable(false);
    }, 500);
  }, [final_Targetdata, selectedActivity]);

  useEffect(() => {
    var tempOverlayExportData: any = [];

    overlayExportDetails?.length > 0 && overlayExportDetails.map((val: any) => {
      const WordSelectionType = val.SelectionType.split(':')[0].trim();
      console.log('WordSelectionType: ', WordSelectionType)
      let Scope = WordSelectionType === 'All Devices' ? 'All Devices' : WordSelectionType === 'Machine' || WordSelectionType === '' ? (
        "Machine"
      ) : (
        "WordSelectionType"
      )

      const statusdata = val.JobStatus;
      if (statusdata === 0) {
        message = 'Pending';
      } else if (statusdata === 2) {
        message = 'Success';
      } else if (statusdata === 3) {
        message = 'Failed';
      } else {
        message = 'Failed';
      }

      tempOverlayExportData.push({
        "Device Name": val.MachineTag ? val.MachineTag : " -",
        "Solution Status": statusdata ? statusdata : " -",
        "Executed Time": val.JobCreatedTime ? convertToExcelFormat(val.JobCreatedTime) : " -",
      });
    });

    setExportOverlayStatusData(tempOverlayExportData);
  }, [overlayExportDetails]);

  useEffect(() => {
    exportOverlayStatusData.length > 0 && document.getElementById('csv-export-link-overlay')?.click();
    setOverlayProgressLoading(false);
  }, [exportOverlayStatusData]);

  //Solu details
  useEffect(() => {
    let automationSequencesArray: any = [];
    let automationWithoutConditionIds: any = [];
    console.log('Selected Activity final_Targetdata:', final_Targetdata);

    if (final_Targetdata !== undefined && final_Targetdata !== null && final_Targetdata) {
      final_Targetdata.forEach((val: any, i: any) => {
        console.log('final_Targetdata: ', val)
        const jsonData = val && val.AutomationJSON.jsonValue;
        console.log('jsonData: ', jsonData)
        const parsedData = JSON.parse(jsonData);
        console.log('parsedData: ', parsedData)
        const automationSequence = parsedData.automation_sequence;

        automationSequencesArray.push(automationSequence);
      });
    } else {
      console.log(null);
    }

    if (final_Targetdata !== undefined && final_Targetdata !== null && final_Targetdata) {
      automationWithoutConditionIds = final_Targetdata.map((val: any) => {
        return {
          automationName: val.automationName,
          id: val.id,
        };
      });
    } else {
      console.log(null);
    }
    console.log("Automation Sequences Array:", automationSequencesArray);
    console.log("Automation Without Condition IDs:", automationWithoutConditionIds);

    const uniqueIds = new Set();
    if (automationSequencesArray.length > 0) {
      let sequenceIds = automationSequencesArray[0]?.split(',').map((id: any) => parseInt(id?.trim()));
      setAutomationIds(sequenceIds);
      console.log("sequenceIds************", sequenceIds);

      let matchingAutomations = automationJsonData.filter((automation: any) => sequenceIds?.includes(automation?.id));

      const automationNames = matchingAutomations.map((data: any) => data?.automationName);

      const uniqeAutoName = new Set(automationNames);
      const uniqueAutoNames = [...(uniqeAutoName as unknown as any[])];
      console.log("Each automationNames*****************", uniqueAutoNames);
      setUniqueAutomationNames(uniqueAutoNames);

    } else {
      console.log("automationSequencesArray is empty");
    }

  }, [final_Targetdata, selectedActivity, overlayOpen]);

  //overlay code starts here
  var overLayData: any = {
    headerTitle: (
      <>
        <Stack>
          <FluentProvider theme={dashboardTheme}>
            <Title3>Troubleshooter Status Details</Title3>
          </FluentProvider>
        </Stack>
      </>
    ),
    size: 'large',
    isTabs: true,
    tabItems: {
      Activity: (
        <Stack>
          {loadingAutomationData ? (
            <DynamicSkeleton count={12} size={48} gap={10} style={skeleton12} />
          ) : (
            // Your existing Activity content
            <Stack tokens={{ childrenGap: 10, padding:'10px 0px'}}>
              {automationName ? (
                <>
                  <StackItem>
                    <Subtitle2Stronger>Automation Name: </Subtitle2Stronger>
                    {automationName}
                  </StackItem>
                  <StackItem>
                    <Subtitle2Stronger>Created By: </Subtitle2Stronger> {createdBy}
                  </StackItem>
                </>
              ) : (
                <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: "10px 0px" }}>
                  <StackItem>
                    <Text size={500}>No result.</Text>
                  </StackItem>
                </Stack>
              )}

              {automationJsonAuditData && automationJsonAuditData.length > 0 && (
                <>
                  <StackItem>
                    {' '}
                    <Subtitle2Stronger> Solution name : </Subtitle2Stronger> {jsonValue.automation_name}{' '}
                  </StackItem>
                  <StackItem>
                    {' '}
                    <Subtitle2Stronger> Solution description : </Subtitle2Stronger> {jsonValue.description}{' '}
                  </StackItem>
                  <StackItem>
                    {' '}
                    <Subtitle2Stronger> Category Name : </Subtitle2Stronger> {jsonValue.category}{' '}
                  </StackItem>
                  <StackItem>
                    {' '}
                    <Subtitle2Stronger> Category description : </Subtitle2Stronger> {jsonValue.category_description}{' '}
                  </StackItem>
                  <StackItem>
                    {' '}
                    <Subtitle2Stronger> Sub Category Name : </Subtitle2Stronger>
                    {jsonValue.sub_category}{' '}
                  </StackItem>
                  <StackItem>
                    {' '}
                    <Subtitle2Stronger>Sub Category description : </Subtitle2Stronger> {jsonValue.sub_category_description}{' '}
                  </StackItem>
                </>
              )}
              <StackItem>
                <Stack tokens={{ childrenGap: 10 }}>
                  {automationJsonAuditData.map((data: any, inx: any) => {
                    const WordSelectionType = data.SelectionType.split(' ')[0];

                    return (
                      <>
                        <Stack tokens={{ childrenGap: 10 }}>
                          <StackItem>
                            <Subtitle2Stronger>Job Created Time: </Subtitle2Stronger>
                            {convertToLocalTimezone(data.JobCreatedTime, userTimeZone)}
                          </StackItem>

                          <StackItem>
                            <Subtitle2Stronger>Scope:</Subtitle2Stronger>
                            {WordSelectionType === 'All Devices' ? (
                              <span> All Devices </span>
                            ) : WordSelectionType === 'Machine' || WordSelectionType === '' ? (
                              <span>{final_Targetdata?.length} Machine</span>
                            ) : (
                              <span> {`Classification: ${WordSelectionType}`} </span>
                            )}
                          </StackItem>

                          <StackItem>
                            {' '}
                            <Subtitle2Stronger>Agent Id:</Subtitle2Stronger> {data.AgentUniqId}
                          </StackItem>

                          <StackItem>
                            {' '}
                            <Subtitle2Stronger>Agent Name:</Subtitle2Stronger> {data.AgentName.length > 0 ? data.AgentName : '-'}
                          </StackItem>
                        </Stack>
                      </>
                    );
                  })}
                </Stack>
              </StackItem>
            </Stack>
          )}
        </Stack>
      ),
      Targets: (
        <Stack tokens={{ childrenGap: 15 }} style={DynamicBoxingCSS} >
          <StackItem>
            <Text></Text>
          </StackItem>
          {/* <InfoBar showSpaces={true} title={"Try changing or adding filters if you don't see what you're looking for."} /> */}
          {(contextValue?.logedInFrom === undefined || contextValue?.logedInFrom?.device?.length === undefined) && (
            <StackItem>
              <StackItem>
                <Stack wrap horizontal tokens={{ childrenGap: 20 }}>
                  {/* <SearchBar columnSearch={"for Device Name"} searchVal={searchVal} setSearchVal={setSearchVal} /> */}
                  <StackItem>
                    <SearchBar
                      columnSearch={'for Device Name'}
                      searchVal={deviceSearchVal}
                      setSearchVal={setDeviceSearchVal}
                      setLoading={setLoadingTable}
                      disabled={loadingTable || final_Targetdata?.length === 0}
                    />
                  </StackItem>
                  <StackItem>
                    <MenuDropdown
                      open={filterMenuOpenOverlay}
                      btn={
                        <MenuButton disabled={loadingTable || final_Targetdata?.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpenOverlay(true)}>
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            {loadingTable || final_Targetdata?.length === 0 ? <FilterAdd20Filled {...secondaryIcon} /> : <FilterAdd20Filled {...primaryIcon} />}
                            <Body1> Filter </Body1>
                          </Stack>
                        </MenuButton>
                      }
                      itemVal={
                        <>
                          <Body1Strong> Add a Filter </Body1Strong>
                          <Divider />
                          <MenuList>
                            <Stack tokens={{ childrenGap: 5 }}>
                              <StackItem>
                                {' '}
                                <Text></Text>{' '}
                              </StackItem>
                              <StackItem>
                                {' '}
                                <Caption1> Filter </Caption1>{' '}
                              </StackItem>
                              <DropdownComponent
                                optionData={overlayColumns}
                                setDropDownValue={setDropDownValue1Overlay}
                                dropDownvalue={dropDownValue1Overlay}
                              />
                              <StackItem>
                                {' '}
                                <Divider />{' '}
                              </StackItem>
                              <StackItem>
                                {' '}
                                <Caption1> Value </Caption1>{' '}
                              </StackItem>
                              {dropDownValue1Overlay === 'Executed Time' && (
                                <DatepickerComponent setDropDownValue2={setDropDownValue2Overlay} maxDate={true} />
                              )}
                              {(dropDownValue1Overlay === 'Device Name' || dropDownValue1Overlay === 'Solution Status') && (
                                <Input size="small" onChange={overlayInputChange} name="filter" value={dropDownValue2Overlay} />
                              )}
                              <StackItem>
                                <Divider />
                              </StackItem>
                              <Stack tokens={{ childrenGap: 10 }} horizontal>
                                <StackItem>
                                  <Button shape="circular"
                                    appearance="primary"
                                    onClick={() => {
                                      handleOverlayFilter();
                                      setFilterMenuOpenOverlay(false);
                                    }}
                                    disabled={
                                      dropDownValue2Overlay == undefined ||
                                        dropDownValue2Overlay?.length === 0 ||
                                        dropDownValue1Overlay == undefined ||
                                        dropDownValue1Overlay?.length === 0 ||
                                        overlayFilterArray.includes(`${dropDownValue1Overlay}:`)
                                        ? true
                                        : false
                                    }
                                  >
                                    <Caption1> Apply </Caption1>
                                  </Button>
                                </StackItem>
                                <StackItem>
                                  <Button shape="circular" onClick={() => { setFilterMenuOpenOverlay(false); setIsOverlayFilter(false); setDropDownValue1Overlay(''); setDropDownValue2Overlay(''); }}>
                                    <Caption1> Cancel </Caption1>
                                  </Button>
                                </StackItem>
                              </Stack>
                            </Stack>
                          </MenuList>
                        </>
                      }
                    />
                  </StackItem>
                  <StackItem>
                    {overlayFilterArray.length > 0 &&
                      overlayFilterArray.map((item, index) => (
                        <Button shape="circular" size="small">
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {item.includes('00:00') ? item.split('00:00')[0].trim() : item} </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 1 }}>
                                <StackItem>
                                  <Text></Text>
                                </StackItem>
                                <StackItem>
                                  <Dismiss16Regular
                                    onClick={() => {
                                      handleCloseOverlayFilter(index);
                                    }}
                                  />
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        </Button>
                      ))}
                  </StackItem>
                  <StackItem
                    onClick={() => {
                      setOverlayFilterArray([]);
                      setIsOverlayFilter(false);
                      setDropDownValue2Overlay('');
                      setOverlayFilterResetDisabled(true);
                      setLoadingTable(true);
                    }}
                  >
                    <Button shape="circular" appearance="subtle" size="small" disabled={isOverlayFilterResetDisabled}>
                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                        <StackItem>
                          {' '}
                          <FilterDismiss20Filled />{' '}
                        </StackItem>
                        <StackItem>
                          {' '}
                          <Caption1> Reset Filters </Caption1>{' '}
                        </StackItem>
                      </Stack>
                    </Button>
                  </StackItem>
                  <StackItem>
                    {overlayFilterArray.length > 0 &&
                      overlayFilterArray.map((item, index) => (
                        <Button shape="circular" size="small">
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem> {item} </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 1 }}>
                                <StackItem>
                                  <Text></Text>
                                </StackItem>
                                <StackItem>
                                  <Dismiss16Regular
                                    onClick={() => {
                                      handleCloseOverlayFilter(index);
                                    }}
                                  />
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        </Button>
                      ))}
                  </StackItem>
                  <StackItem>
                    {permissions.includes('all') || permissions.includes('status_Fullaccess') || permissions.includes('status_ReadandExport') ? (
                      <StackItem>
                        <CSVLink id="csv-export-link-overlay" data={exportOverlayStatusData} filename={`${tenantName}_statusactivitylist.csv`}></CSVLink>
                        <Button shape="circular"
                          appearance="subtle"
                          size="small"
                          onClick={() => {
                            setOverlayExportBtnClicked(true);
                            setOverlayProgressLoading(true);
                          }}
                          disabled={automationJsonAuditData.length === 0 ? true : false}
                        >
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>
                              {' '}
                              <ArrowDownload20Regular {...primaryIcon} />{' '}
                            </StackItem>
                            <StackItem>
                              {' '}
                              <Caption1> Export </Caption1>{' '}
                            </StackItem>
                          </Stack>
                        </Button>
                      </StackItem>
                    ) : (
                      <Tooltip withArrow content={'You do not have access'} relationship="description" positioning="above">
                        <Button shape="circular" appearance="subtle" size="small" disabled>
                          <Stack tokens={{ childrenGap: 5 }} horizontal>
                            <StackItem>
                              <Text></Text>
                            </StackItem>
                            <StackItem>
                              <Stack tokens={{ childrenGap: 5 }} horizontal>
                                <StackItem>
                                  {' '}
                                  <ArrowDownload20Regular {...secondaryIcon} />{' '}
                                </StackItem>
                                <StackItem>
                                  <Caption1> Export </Caption1>
                                </StackItem>
                              </Stack>
                            </StackItem>
                          </Stack>
                        </Button>
                      </Tooltip>
                    )}
                  </StackItem>
                </Stack>
              </StackItem>
            </StackItem>
          )}

          <StackItem style={DynamicBoxingCSS} >
            {final_Targetdata?.length > 0 && !loadingTable && (
              <Stack horizontal enableScopedSelectors horizontalAlign="space-between">
                <StackItem>
                  {' '}
                  {totalOverlayRecords > 0 && (
                    <Caption1>
                      {' '}
                      Showing {(currentOverlayPageNo - 1) * 50 + 1} to{' '}
                      {currentOverlayPageNo * 50 > totalOverlayRecords ? totalOverlayRecords : currentOverlayPageNo * 50} of {totalOverlayRecords}{' '}
                      Records{' '}
                    </Caption1>
                  )}{' '}
                </StackItem>
                <StackItem>
                  {' '}
                  <Pagination
                    setLoading={setLoadingTable}
                    totalPages={totalOverlayPages}
                    currentPageNo={currentOverlayPageNo}
                    setCurrentPageNo={setCurrentOverlayPageNo}
                  />{' '}
                </StackItem>
              </Stack>
            )}
            {/* <Status_target_fun data={final_Targetdata} func={set_final_Targetdata} selectedAct={selectedActivity} searchVal={searchTargetVal} setAutomationJsonData={setAutomationJsonData} automationIds={automationIds} /> */}

            {/* {statusTableData.length > 0 ? (<DataTable tableData={statusTableData} columns={overlayColumns} />) : <Stack horizontalAlign="center"  tokens={{childrenGap: 15, padding: 10}}><StackItem><Text size={500}>No data available</Text></StackItem></Stack>} */}

            {loadingTable ? (
              <SkeletonOverlayDataTable />
            ) : final_Targetdata?.length > 0 ? (
              <DataTable tableData={statusTableData} columns={overlayColumns} />
            ) : (
              <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}>
                <StackItem>
                  <Text size={500}>No result.</Text>
                </StackItem>
              </Stack>
            )}
          </StackItem>
        </Stack>
      ),
      // 'Solution Details': (
      //   <Stack>
      //     {/* HI */}

      //     <Stack tokens={{ childrenGap: 10, padding: 10 }}>
      //       <Stack tokens={{ childrenGap: 10, padding: 10 }}>
      //         <StackItem>
      //           <Text>
      //             <Subtitle2Stronger>Below are the automation sequence executed,</Subtitle2Stronger>
      //           </Text>
      //         </StackItem>
      //         <StackItem>
      //           <Text></Text>
      //         </StackItem>
      //         {uniqueAutomationNames.map((name, index) => (
      //           <>
      //             <StackItem>
      //               {' '}
      //               <Text>&bull; {name} </Text>{' '}
      //             </StackItem>
      //             <StackItem>
      //               {' '}
      //               <Text> </Text>{' '}
      //             </StackItem>
      //           </>
      //         ))}
      //       </Stack>
      //     </Stack>
      //   </Stack>
      // ),
    },
  };
  //overlay code ends here


  useEffect(() => {
    if (!overlayOpen) {
      setLoadingTable(true);
      //   setLoadingAutomationData(true);
      setAutomationJsonAuditData([]);
      setAutomationName('');
      set_final_Targetdata([]);
      //setselectedActivity({ name: '', time: '' });
      setAutomationIds([]);
    } else {
      setLoadingTable(true); // Set loading to true when overlay opens
      //   setLoadingAutomationData(true);     // Set
    }
  }, [overlayOpen]);

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink style={BreadcrumbsBorder}>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            {contextValue?.logedInFrom?.platform !== "ServiceNow" && <StackItem grow shrink>
              <Stack tokens={{ childrenGap: 5 }} horizontalAlign="start">
                <StackItem><Text></Text></StackItem>
                <StackItem grow shrink>
                  {/* <Breadcrumbs pageName="Alert" subPageName="" subPageLink="#" />  */}
                  <Breadcrumbs
                    items={[
                      { name: "Manage", link: "/home" },
                      { name: "Troubleshoot", link: "/manage/troubleshoot/alert" },
                      { name: "Status", link: "#" }
                    ]}
                  />
                </StackItem>
              </Stack>
            </StackItem>}
          </Stack>
        </StackItem>
        <Stack style={SubSectionResponsive} tokens={{ childrenGap: 20 }} horizontal>
          <StackItem style={DynamicBoxingCSS}>
            {/* pages code starts here */}
            <Stack style={DynamicBoxingCSS}>
              {/* <Stack tokens={{ childrenGap: 25 }} horizontal>
                                <StackItem><Text/></StackItem>
                                <StackItem>
                                    <FluentProvider theme={dashboardTheme}>
                                        <Title3>Troubleshooting | Status</Title3>
                                    </FluentProvider>
                                </StackItem>
                            </Stack> */}
              <FluentProvider style={parentHome} theme={dashboardTheme}>
                <Stack style={parentHome} horizontal>
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={TroubleshootPages("Status")} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} className={isProgressLoading ? 'disabled-opacity' : ''} verticalAlign="center" tokens={{ childrenGap: 10 }}>
                      <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                        <StackItem>
                          <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                          <Stack>{isProgressLoading && <ProgressBar />}</Stack>
                          <Divider />
                        </StackItem>
                        <StackItem>
                          <StackItem style={wraperStyle}>
                            <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                              <Stack horizontal tokens={{ childrenGap: 10 }}>
															<StackItem>
                                <SearchBar searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                                </StackItem>
                                <StackItem>
                                  <MenuDropdown open={filterMenuOpen} btn={
                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={<><Body1Strong> Add a Filter </Body1Strong>
                                    <Divider />
                                    <MenuList>
                                      <Stack tokens={{ childrenGap: 5 }}>
                                        <StackItem> <Text></Text> </StackItem>
                                        <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                        {/* <DropdownComponent optionData={columns} /> */}
                                        <DropdownComponent optionData={filterColumnsData} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                                        <StackItem> <Divider /> </StackItem>
                                        <StackItem> <Caption1> Value </Caption1> </StackItem>
                                        {/* <DropdownComponent optionData={columns} /> */}
                                        {/* <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} /> */}
                                        {dropDownValue1 === 'Date' && <DatepickerComponent setDropDownValue2={setDropDownValue2} maxDate={true} />}
                                        {(dropDownValue1 === "Solution" || dropDownValue1 === "Initiated by" || dropDownValue1 === "Scope") && <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />}
                                        <StackItem> <Divider /> </StackItem>
                                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                                          <StackItem>
                                            <Button shape="circular"
                                              appearance="primary"
                                              onClick={() => { handleFilterArray(); setFilterMenuOpen(false); }}
                                              disabled={!dropDownValue1 || !dropDownValue2 || filterArray.some(filter => filter.startsWith(`${dropDownValue1} :`))}
                                            >  <Caption1> Apply </Caption1> </Button>
                                          </StackItem>
                                          <StackItem>
                                            <Button shape="circular" onClick={() => { setFilterMenuOpen(false); setDropDownValue1(''); setDropDownValue2(''); }}>
                                              <Caption1> Cancel </Caption1>
                                            </Button>
                                          </StackItem>
                                        </Stack>
                                      </Stack>
                                    </MenuList>
                                  </>} />
                                </StackItem>
                                <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); setLoading(true) }}>
                                  <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> <FilterDismiss20Filled /> </StackItem>
                                      <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                    </Stack>
                                  </Button>
                                </StackItem>
                              </Stack>
                              {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                            </Stack>
                            {filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                              <Stack wrap horizontal >
                                {filterArray.length > 0 && filterArray.map((item, index) => (
                                  <Button shape="circular" size="small">
                                    <Stack tokens={{ childrenGap: 5 }} horizontal>
                                      <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                      <StackItem>
                                        <Stack tokens={{ childrenGap: 1 }}>
                                          <StackItem><Text></Text></StackItem>
                                          <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                        </Stack>
                                      </StackItem>
                                    </Stack>
                                  </Button>
                                ))}
                              </Stack>
                            </Stack>}
                          </StackItem>
                          <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                          {tableData.length > 0 && !loading && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                            <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                          </Stack>}
                        </StackItem>
                        <Status_func filterArray={filterArray} data={final_data} func={set_final_data} searchVal={searchVal} pageNo={(currentPageNo - 1) * 50} setTotalPages={setTotalPages} setTotalRecords={setTotalRecords} isRefresh={isRefresh} setIsRefresh={setIsRefresh} setRefreshToast={setRefreshToast} activityData={final_data2} activityFunc={set_final_data2} selectedAct={selectedActivity} isFilter={isfilter} dropDownValue1={dropDownValue1} setIsFilter={setIsFilter} dropDownValue2={dropDownValue2} final_Targetdata={final_Targetdata} set_final_Targetdata={set_final_Targetdata} searchTargetVal={searchTargetVal} setAutomationJsonData={setAutomationJsonData} automationIds={automationIds} isOverlayFilter={isOverlayFilter} dropDownValue1Overlay={dropDownValue1Overlay} setIsOverlayFilter={setIsOverlayFilter} dropDownValue2Overlay={dropDownValue2Overlay} deviceSearchVal={deviceSearchVal} overlayFilterArray={overlayFilterArray} overlayPageNo={(currentOverlayPageNo - 1) * 50} setTotalOverlayPages={setTotalOverlayPages} setTotalOverlayRecords={setTotalOverlayRecords} setExportDetails={setExportDetails} exportBtnClicked={exportBtnClicked} setExportBtnClicked={setExportBtnClicked} setOverlayExportDetails={setOverlayExportDetails} setOverlayExportBtnClicked={setOverlayExportBtnClicked} overlayExportBtnClicked={overlayExportBtnClicked} jobType={pageName} />

                        {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={tableColumnsData} ></DataTable>) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}

                        {refreshToast && <ToastComponent setmessagebar={setRefreshToast} isToastEnabled={refreshToast} toastIntent="success" position="top-end" title="Success" message={'Data Table Refreshed'} footer="" />}

                      </Stack>
                    </Stack>
                  </StackItem>
                </Stack>
              </FluentProvider>
            </Stack>
            <OverLay
              overlayopen={overlayOpen}
              setOverlayOpen={setOverlayOpen}
              overlayData={overLayData}
            // isNavBtn={true}
            />
          </StackItem>
          <StackItem><Text></Text></StackItem>
        </Stack>
      </FullScreen>
    </>
  );
};
